'use client';

import { SidebarTrigger } from '@/components/ui/sidebar';

/**
 * The shared collapse rail — the narrow vertical strip between the left nav and
 * the page content that holds the sidebar-collapse toggle. Rendered once by the
 * unified top-level shell (`LayoutWrapper`) for every top-level page (Matters,
 * Scribe, Intake, Templates), so the rail width is single-sourced and can't
 * drift (LF-5279). Fixed narrow width; toggle sits top-left. The bg-white
 * column stretches to the parent's height via flex.
 */
export function CollapseRail() {
  return (
    <div className="flex w-8 shrink-0 flex-col bg-white pl-1.5">
      <div className="pt-4">
        <SidebarTrigger />
      </div>
    </div>
  );
}
